<div class="mat-h6 text-end">v{{ _currentApplicationVersion }}</div>
